import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Layout from "../common/layout/Layout";

const ProtectedRoute = ({ element, userTypes: allowedUserTypes, withLayout = true }) => {
  const { authenticated, userInfo } = useSelector((state) => state.auth);
  const userTypes = userInfo?.userTypes || [];
  const allowed = !allowedUserTypes || allowedUserTypes.some((userType) => userTypes.includes(userType));

  if (!authenticated) {
    return <Navigate to="/login" />;
  }
  if (!allowed) {
    return <Navigate to="/" />;
  }
  return withLayout ? <Layout element={element} /> : element;
};

ProtectedRoute.propTypes = {
  element: PropTypes.element.isRequired,
  userTypes: PropTypes.array,
  withLayout: PropTypes.bool,
};

export default ProtectedRoute;
